import { addDays, startOfDay } from "date-fns";

export function retrieveSessionDateRange() {
  const sessionDateRange = localStorage.getItem("sessionDateRange");

  if (sessionDateRange) {
    return JSON.parse(sessionDateRange);
  } else {
    // Default to Last 30 Days
    return {
      start: startOfDay(addDays(new Date(), -30)),
      end: new Date(),
    };
  }
}
